// // LandingPage.jsx
// import React, { useState, useRef, useEffect } from "react";
// import "./LandingPage.css";

// export default function LandingPage({ onVerified }) {
//   const [showResume, setShowResume] = useState(false);
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [emailError, setEmailError] = useState(false);
//   const [otpError, setOtpError] = useState(false);
//   const [otpSentMsg, setOtpSentMsg] = useState("");
//   const otpRefs = useRef([]);

//   useEffect(() => {
//     if (step === 2) otpRefs.current[0]?.focus();
//   }, [step]);

//   const showResumePanel = () => {
//     setShowResume(true);
//     setStep(1);
//     setEmail("");
//     setOtp(["", "", "", "", "", ""]);
//     setEmailError(false);
//     setOtpError(false);
//     setOtpSentMsg("");
//   };

//   const sendResumeOtp = () => {
//     if (!email) {
//       setEmailError(true);
//       return;
//     }
//     setEmailError(false);
//     setStep(2);
//     setOtp(["", "", "", "", "", ""]);
//     setOtpSentMsg(`Verification code sent to ${email}`);
//     setOtpError(false);
//   };

//   const handleOtpChange = (e, index) => {
//     const value = e.target.value;
//     if (/^[0-9]?$/.test(value)) {
//       const newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);
//       if (value && index < 5) otpRefs.current[index + 1]?.focus();
//     }
//   };

//   const verifyResumeOtp = () => {
//     const enteredOtp = otp.join("");
//     if (enteredOtp === "123456") {
//       setOtpError(false);
//       onVerified();
//     } else {
//       setOtpError(true);
//     }
//   };

//   const resendOtp = () => {
//     setOtp(["", "", "", "", "", ""]);
//     setOtpError(false);
//     setOtpSentMsg(`Verification code re-sent to ${email}`);
//   };

//   return (
//      <div className="landing-screen">
//     <div className="landing-card">
//       <div className="landing-hero">
//         <div className="lh-eyebrow">Center for Hypertension</div>
//         <h1>New Patient<br />Registration</h1>
//         <p>
//           Welcome. Complete your registration at your own pace — your progress is saved automatically after the first page.
//         </p>
//       </div>

//       <div className="landing-body">
//         {!showResume && (
//           <>
//             <button className="landing-btn-primary" onClick={onVerified}>
//               Begin Registration
//             </button>
//             <div className="landing-divider">or</div>
//             <button className="landing-btn-secondary" onClick={showResumePanel}>
//               Continue Existing Application
//             </button>
//           </>
//         )}

//         {showResume && (
//           <div className="resume-panel">
//             {step === 1 && (
//               <div className="email-step">
//                 <h3>Enter your email address</h3>
//                 <p>We'll send a verification code to the email you registered with.</p>
//                 <input
//                   type="email"
//                   className="resume-input"
//                   placeholder="your@email.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//                 {emailError && (
//                   <div className="resume-error">No saved application found for this email.</div>
//                 )}
//                 <button className="resume-send-btn" onClick={sendResumeOtp}>
//                   Send Verification Code →
//                 </button>
//               </div>
//             )}

//             {step === 2 && (
//               <div className="otp-step">
//                 <h3>Enter your verification code</h3>
//                 <p>{otpSentMsg}</p>
//                 <div className="otp-inputs">
//                   {otp.map((digit, idx) => (
//                     <input
//                       key={idx}
//                       ref={(el) => (otpRefs.current[idx] = el)}
//                       className="otp-digit"
//                       type="text"
//                       maxLength="1"
//                       inputMode="numeric"
//                       value={digit}
//                       onChange={(e) => handleOtpChange(e, idx)}
//                     />
//                   ))}
//                 </div>
//                 {otpError && (
//                   <div className="resume-error">Incorrect code. Please try again.</div>
//                 )}
//                 <button className="resume-send-btn" onClick={verifyResumeOtp}>
//                   Verify & Resume →
//                 </button>
//                 <div className="otp-resend">
//                   Didn't get it? <button onClick={resendOtp}>Resend code</button>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         <div className="landing-note">
//           🔒 Your information is protected by HIPAA-compliant encryption.<br />
//           Progress is saved after you verify your contact info on page 1.
//         </div>
//       </div>
//     </div>
//     </div>
//   );
// }






// LandingPage.jsx
import React, { useState, useRef, useEffect } from "react";
import api from '../../api/api';
import axios from "axios";
import "./LandingPage.css";
import BrainyCareLogo from "../../../src/assets/auth/BrainyCare-Logo.jpg";
import { UTILITY_BASE } from "../../api/bases";
import { getPracticeId } from "../../config/practice";

export default function LandingPage({ onVerified, setCurrentStep, setIsCompleted, setRowId, setHealthCompleted, setStepsfilled, setFormData }) {
  const [showResume, setShowResume] = useState(false);
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [emailError, setEmailError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpSentMsg, setOtpSentMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState(""); // "error" | "success"
  const [open, setOpen] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState(null);
  const practiseid = getPracticeId();

  const otpRefs = useRef([]);

const formOrder = [
  'form_1', 'form_2', 'form_3', 'form_4', 'form_5', 
  'form_6', 'form_7', 'form_8', 'form_9', 'form_10', 
  'form_11', 'form_12', 'form_13',
  'phq9', 'stopbang', 'adhd', 'mdq'
];

  useEffect(() => {
    if (step === 2) otpRefs.current[0]?.focus();
  }, [step]);

  const showResumePanel = () => {
    setShowResume(true);
    setStep(1);
    setEmail("");
    setOtp(["", "", "", "", "", ""]);
    setEmailError(false);
    setOtpError(false);
    setOtpSentMsg("");
  };

  const showBackMainPanel = () => {
    setShowResume(false);
    setStep(1);
    setEmail("");
    setOtp(["", "", "", "", "", ""]);
    setEmailError(false);
    setOtpError(false);
    setOtpSentMsg("");
  };

  // const validateEmail = (email) => {
  //   const re = /\S+@\S+\.\S+/;
  //   return re.test(email);
  // };

  // const sendResumeOtp = async () => {
  //   if (!email) {
  //     setEmailError(true);
  //     return;
  //   }
  //   if (!validateEmail(email)) {
  //     setEmailError(true);
  //     setAlertMessage("Invalid email address");
  //     setSeverity("error");
  //     setOpen(true);
  //     return;
  //   }

  //   setEmailError(false);
  //   setLoading(true);

  //   try {
  //     // Generate 6-digit OTP
  //     const generatedOtp = Math.floor(100000 + Math.random() * 900000);
  //     console.log("Generated OTP:", generatedOtp);

  //     // For demo, skip actual email sending
  //     // TODO: call your email API here

  //     setOtp(["", "", "", "", "", ""]); // reset OTP inputs
  //     setStep(2);
  //     setOtpSentMsg(`Verification code sent to ${email}`);
  //     setAlertMessage(`OTP sent to ${email}`);
  //     setSeverity("success");
  //     setOpen(true);

  //     // Save OTP in session/localStorage if you want real verification
  //     sessionStorage.setItem("resumeOtp", generatedOtp.toString());
  //   } catch (err) {
  //     console.error(err);
  //     setAlertMessage("Failed to send OTP.");
  //     setSeverity("error");
  //     setOpen(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

// const sendResumeOtp = async () => {
//   const currentEmail = email;
//   if (!currentEmail) {
//     setEmailError(true);
//     setAlertMessage("Please enter your email address.");
//     setSeverity("error");
//     setOpen(true);
//     return;
//   }

//   if (!validateEmail(currentEmail)) {
//     setEmailError(true);
//     setAlertMessage("Invalid email address. Please enter a valid email.");
//     setSeverity("error");
//     setOpen(true);
//     return;
//   }

//   setEmailError(false);
//   setLoading(true);

//   try {
//     // Generate 6-digit OTP
//     const generatedOtp = Math.floor(100000 + Math.random() * 900000); // 100000-999999

//     // Email message with HTML styling
//     const message = `
//       <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9;">
//         <h2 style="color: #555;">Your OTP Code</h2>
//         <p style="font-size: 16px; line-height: 1.6;">
//           Your Verification Code is:
//         </p>
//         <p style="font-size: 24px; font-weight: bold; color: #1d4ed8; margin: 20px 0;">
//           ${generatedOtp}
//         </p>
//         <p style="font-size: 14px; line-height: 1.6;">
//           If you did not request this OTP, you can safely ignore this email.
//         </p>
//         <p style="font-size: 14px; line-height: 1.6; margin-top: 20px;">
//           Thanks,<br />
//           The Team
//         </p>
//       </div>
//     `;

//     // Prepare form data to send to your email API
//     const formData = new FormData();
//     formData.append("subject", "Your OTP Verification Code");
//     formData.append("to", currentEmail);
//     formData.append("message", message);

//     const resp = await axios.post("https://api.prd.brainymed.com/utility/send-email", formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });

//     if (resp.status === 200) {
//       setAlertMessage("OTP sent to your email successfully.");
//       setSeverity("success");
//       setOpen(true);

//       // Reset OTP inputs
//       setOtp(["", "", "", "", "", ""]);
//       setStep(2);
//       setOtpSentMsg(`Verification code sent to ${currentEmail}`);

//       // Store OTP in sessionStorage for verification
//       sessionStorage.setItem("resumeOtp", generatedOtp.toString());
//       console.log("OTP generated:", generatedOtp);

//       // Clear email field if needed
//       // setEmail(""); // optional
//     } else {
//       setAlertMessage(resp.data?.message || "Failed to send OTP.");
//       setSeverity("error");
//       setOpen(true);
//     }
//   } catch (error) {
//     console.error(error);
//     setAlertMessage("Something went wrong while sending OTP.");
//     setSeverity("error");
//     setOpen(true);
//   } finally {
//     setLoading(false);
//   }
// };


const sendResumeOtp = async () => {
  const currentEmail = email;
  if (!currentEmail) {
    setEmailError(true);
    setAlertMessage("Please enter your email address.");
    setSeverity("error");
    setOpen(true);
    return;
  }

  if (!validateEmail(currentEmail)) {
    setEmailError(true);
    setAlertMessage("Invalid email address. Please enter a valid email.");
    setSeverity("error");
    setOpen(true);
    return;
  }

  setEmailError(false);
  setLoading(true);

  try {
    // Generate 6-digit OTP
    const otp = Math.floor(100000 + Math.random() * 900000); // 100000-999999



//       setAlertMessage("OTP sent to your email successfully.");
//       setSeverity("success");
//       setOpen(true);
//       setOtp(["", "", "", "", "", ""]); // reset OTP inputs
//       setStep(2);
//       setOtpSentMsg(`Verification code sent to ${currentEmail}`);
//       console.log("OTP generated:", otp); 

//     setGeneratedOtp('123456');
// return;
    // Email message
    const message = `
      <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9;">
        <h2 style="color: #555;">Your OTP Code</h2>
        <p>Your Verification Code is:</p>
        <p style="font-size: 24px; font-weight: bold; color: #1d4ed8; margin: 20px 0;">
          ${otp}
        </p>
        <p>If you did not request this OTP, you can safely ignore this email.</p>
        <p>Thanks,<br />The Team</p>
      </div>
    `;

    const formData = new FormData();
    formData.append("subject", "Your OTP Verification Code");
    formData.append("to", currentEmail);
    formData.append("message", message);

    const resp = await axios.post(`${UTILITY_BASE}/send-email`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (resp.status === 200) {
      setAlertMessage("OTP sent to your email successfully.");
      setSeverity("success");
      setOpen(true);
      setOtp(["", "", "", "", "", ""]); // reset OTP inputs
      setStep(2);
      setOtpSentMsg(`Verification code sent to ${currentEmail}`);
      console.log("OTP generated:", otp);
      setGeneratedOtp(otp); // Store OTP for verification
    } else {
      setAlertMessage(resp.data?.message || "Failed to send OTP.");
      setSeverity("error");
      setOpen(true);
    }
  } catch (error) {
    console.error(error);
    setAlertMessage("Something went wrong while sending OTP.");
    setSeverity("error");
    setOpen(true);
  } finally {
    setLoading(false);
  }
};

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) otpRefs.current[index + 1]?.focus();
    }
  };

  const verifyResumeOtp = () => {
    const enteredOtp = otp.join("");

    if (enteredOtp == generatedOtp?.toString()) {
      setOtpError(false);
      // onVerified();
      fetchOnboardingFilleddata(); // Fetch filled data to populate form when user resumes
      // setCurrentStep(6); // go to step 6 after verification
      setGeneratedOtp(); // Clear OTP from state after sending email for security
    } else {
      setOtpError(true);
    }
  };


// const fetchOnboardingFilleddata = async () => {
//   setCurrentStep(0);
//   try {
//     setLoading(true);
//     const response = await api.get(`/v1/${practiseid}/onboarding/get?email=${email}`);
// console.log("API Response for filled data:", response);
//     if (response && response?.status === 200 && response?.data?.length > 0) {
//       const raw = response.data[0];
//       console.log("Raw API Response for filled data:", raw);
//       onVerified();

//       let nextStep = 1; // default to 1 if nothing is filled
//       for (let i = formOrder.length - 1; i >= 0; i--) {
//         const key = formOrder[i];
//         if (raw[key] && Object.keys(raw[key]).length > 0) {
//           nextStep = i + 2; // resume from the next step (1-indexed)
//           break;
//         }
//       }

//       // Make sure nextStep does not exceed the number of forms
//       if (nextStep > formOrder.length) nextStep = formOrder.length;
//       if (nextStep > 8) nextStep = 9;      
//       setCurrentStep(nextStep);
//       const isCompleted = nextStep > 8? true : false;
//       console.log("isCompletedisCompleted : ", isCompleted);
//       setIsCompleted(isCompleted);
//       setHealthCompleted({});
//       if(isCompleted) {
//         const completedForms = {
//           phq9: raw.phq9 && Object.keys(raw.phq9).length > 0,
//           stopbang: raw.stopbang && Object.keys(raw.stopbang).length > 0,
//           adhd: raw.adhd && Object.keys(raw.adhd).length > 0,
//           mdq: raw.mdq && Object.keys(raw.mdq).length > 0
//         };
//         setHealthCompleted(completedForms);
//         console.log("completedForms : ", completedForms);
//       }
//       setRowId(raw.id);
//       console.log(raw.id, " IIIDDD " ,isCompleted, ": Next unfilled step :", nextStep);      
//     } else {
//       // No data found, start from step 1      
//       // window.location.reload();
//       setAlertMessage("EmailId not found, Please try again.");
//       setSeverity("error");
//       setOpen(true);
//     }
//   } catch (error) {
//       if (error.response && error.response.status === 404) {
//         setAlertMessage("EmailId not found, Please try again.");
//         setSeverity("error");
//         setOpen(true);
//       } else {
//         setAlertMessage("Something went wrong. Please try again later.");
//         setSeverity("error");
//         setOpen(true);
//         console.error("Error fetching data:", error);
//       }
//   } finally {
//     setLoading(false);  
//   }
// };

const fetchOnboardingFilleddata = async () => {
  try {
    setLoading(true);

    // Encode email to avoid URL issues
    const response = await api.get(
      `/v1/${practiseid}/onboarding/get?email=${encodeURIComponent(email)}`
    );

    console.log("API Response for filled data:", response);

    if (response?.status === 200 && response?.data?.length > 0) {
      const raw = response.data[0];
      console.log("Raw API Response for filled data:", raw);

      

try {
  // 1. Parse all forms safely
  const safeParse = (str) => {
    try {
      return str ? JSON.parse(str) : {};
    } catch (err) {
      console.error("Failed to parse form:", err);
      return {};
    }
  };

  const form1Data = safeParse(raw.form_1);
  const form2Data = safeParse(raw.form_2);
  const form3Data = safeParse(raw.form_3);
  const form4Data = safeParse(raw.form_4);
  const form5Data = safeParse(raw.form_5);
  const form6Data = safeParse(raw.form_6);
  const form7Data = safeParse(raw.form_7);
  const form8Data = safeParse(raw.form_8);
console.log("form1Data : ", form1Data);
  setFormData(prev => ({
    ...prev,

    // ---------- FORM 1 ----------
    firstName: form1Data.firstname || "",
    lastName: form1Data.lastname || "",
    dateOfBirth: form1Data.dob || "",
    gender: form1Data.gender || "",
    maritalStatus: form1Data.maritalstatus || "",
    referredBy: form1Data.referrredby || "",
    referredByOther: form1Data.referrredby_other || "",
    phoneNumber: form1Data.phone || "",
    email: form1Data.email || "",
    address: form1Data.address || "",
    city: form1Data.city || "",
    zipCode: form1Data.zipcode || "",
    emergencyContact: form1Data.emergencycontact || "",
    emergencyPhone: form1Data.emergencyphone || "",

    // ---------- FORM 2 ----------
    paymentMethod: form2Data.paymentMethod || "",

    primaryInsurance: form2Data.primaryinsurance || "",
    relationshipToYou: form2Data.primaryrelationship || "",
    subscriberName: form2Data.primarysubscribername || "",
    subscriberId: form2Data.subscriberid || "",
    subscriberDOB: form2Data.primarydob || "",
    groupId: form2Data.groupid || "",
    subscriberSSN: form2Data.primaryssn || "",

    secondaryInsurance: [
      {
        primaryInsurance: form2Data.secondaryinsurance?.[0]?.primaryInsurance || "",
        subscriberName: form2Data.secondaryinsurance?.[0]?.subscriberName || "",
        subscriberDOB: form2Data.secondaryinsurance?.[0]?.subscriberDOB || "",
        subscriberSSN: form2Data.secondaryinsurance?.[0]?.subscriberSSN || "",
        relationshipToYou: form2Data.secondaryinsurance?.[0]?.relationshipToYou || "",
        subscriberId: form2Data.secondaryinsurance?.[0]?.subscriberId || "",
        groupId: form2Data.secondaryinsurance?.[0]?.groupId || "",
      },
    ],

    tertiaryInsurance: [
      {
        primaryInsurance: form2Data.tertiaryinsurance?.[0]?.primaryInsurance || "",
        subscriberName: form2Data.tertiaryinsurance?.[0]?.subscriberName || "",
        subscriberDOB: form2Data.tertiaryinsurance?.[0]?.subscriberDOB || "",
        subscriberSSN: form2Data.tertiaryinsurance?.[0]?.subscriberSSN || "",
        relationshipToYou: form2Data.tertiaryinsurance?.[0]?.relationshipToYou || "",
        subscriberId: form2Data.tertiaryinsurance?.[0]?.subscriberId || "",
        groupId: form2Data.tertiaryinsurance?.[0]?.groupId || "",
      },
    ],

    workersComp: form2Data.workercompensation || "",
    autoAccident: form2Data.autoaccident || "",

    // ---------- FORM 3 ----------
    healthConcerns: form3Data.healthconcerns || "",
    medications: form3Data.medications || "",
    surgicalHistory: form3Data.surgicalHistory || "",
    allergies: form3Data.allergies || "",
    noFamilyHistory: form3Data.noFamilyHistory || false,
    medicalHistory: form3Data.medicalHistory || "",
    otherProblemDetails: form3Data.otherProblemDetails || "",
    seriousConditions: form3Data.seriousConditions || "",

    // ---------- FORM 4 ----------
    familyHistory: form4Data.familyHistory || "",

    // ---------- FORM 5 ----------
    tobaccoUse: form5Data.tobaccoUse || "",
    tobaccoQuestions: form5Data.tobaccoQuestions || "",
    alcoholUse: form5Data.alcoholUse || "",
    alcoholQuestions: form5Data.alcoholQuestions || "",
    recreationalDrugs: form5Data.recreationalDrugs || "",
    drugQuestions: form5Data.drugQuestions || "",
    sexualActive: form5Data.sexualActive || "",
    sexualityQuestions: form5Data.sexualityQuestions || "",
    ethnicBackground: form5Data.ethnicBackground || "",
    numberChildren: form5Data.numberChildren || "",
    whoLiveWithYou: form5Data.whoLiveWithYou || "",
    occupation: form5Data.occupation || "",
    education: form5Data.education || "",
    botheredByProblems: form5Data.botheredByProblems || "",
    littlePleasure: form5Data.littlePleasure || "",

    // ---------- FORM 6 ----------
    careTeam: form6Data.careTeam || [],
    homeHealthCompany: form6Data.homeHealthCompany || "",

    // ---------- FORM 7 ----------
    // reviewOfSystems: form7Data.reviewOfSystems || [],
    // rosOther: form7Data.rosOther || "",
    reviewOfSystems: form7Data.reviewOfSystems || {},
    flattenedROS: Object.values(form7Data.reviewOfSystems || {}).flat(),
    rosOther: form7Data.rosOther || "",

    // ---------- FORM 8 ----------
    immunizations: {
      hepatitisA: { received: form8Data.immunizations?.hepatitisA?.received || false, date: form8Data.immunizations?.hepatitisA?.date || "" },
      hepatitisB: { received: form8Data.immunizations?.hepatitisB?.received || false, date: form8Data.immunizations?.hepatitisB?.date || "" },
      pneumonia: { received: form8Data.immunizations?.pneumonia?.received || false, date: form8Data.immunizations?.pneumonia?.date || "" },
      shingles: { received: form8Data.immunizations?.shingles?.received || false, date: form8Data.immunizations?.shingles?.date || "" },
      measles: { received: form8Data.immunizations?.measles?.received || false, date: form8Data.immunizations?.measles?.date || "" },
      mumps: { received: form8Data.immunizations?.mumps?.received || false, date: form8Data.immunizations?.mumps?.date || "" },
      rubella: { received: form8Data.immunizations?.rubella?.received || false, date: form8Data.immunizations?.rubella?.date || "" },
      varicella: { received: form8Data.immunizations?.varicella?.received || false, date: form8Data.immunizations?.varicella?.date || "" },
      tetanus: { received: form8Data.immunizations?.tetanus?.received || false, date: form8Data.immunizations?.tetanus?.date || "" },
      hpv: { received: form8Data.immunizations?.hpv?.received || false, date: form8Data.immunizations?.hpv?.date || "" },
      meningitis: { received: form8Data.immunizations?.meningitis?.received || false, date: form8Data.immunizations?.meningitis?.date || "" },
      otherVaccine: { received: form8Data.immunizations?.otherVaccine?.received || false, date: form8Data.immunizations?.otherVaccine?.date || "" },
      otherVaccineDetails: form8Data.otherVaccineDetails || "",
      flu: { received: form8Data.immunizations?.flu?.received || false, date: form8Data.immunizations?.flu?.date || "" }
    },
    fluTolerance: form8Data.fluTolerance || "",

    // ---------- Health Screening ----------
    phq9: raw.phq9 || {},
    stopbang: raw.stopbang || {},
    adhd: raw.adhd || {},
    mdq: raw.mdq || {}
  }));
// setPaymentMethod(form2Data.paymentMethod || "insurance");

} catch (error) {
  console.error("Error mapping API data to formData:", error);
}





      // Mark email as verified
      onVerified();

      // Determine the next step
      let nextStep = 1; // default if nothing is filled
      for (let i = formOrder.length - 1; i >= 0; i--) {
        const key = formOrder[i];
        if (raw[key] && Object.keys(raw[key]).length > 0) {
          nextStep = i + 2; // resume from the next step (1-indexed)
          break;
        }
      }

      // Cap nextStep correctly
      nextStep = Math.min(nextStep, formOrder.length, 9);
      console.log("setCurrentStep ", nextStep);
      setCurrentStep(nextStep);

      const isCompleted = nextStep > 8;
      setIsCompleted(isCompleted);

      // Track which forms are completed
      if (isCompleted) {
        const completedForms = {
          phq9: !!raw.phq9 && Object.keys(raw.phq9).length > 0,
          stopbang: !!raw.stopbang && Object.keys(raw.stopbang).length > 0,
          adhd: !!raw.adhd && Object.keys(raw.adhd).length > 0,
          mdq: !!raw.mdq && Object.keys(raw.mdq).length > 0
        };
        setHealthCompleted(completedForms);
        console.log("Completed Forms:", completedForms);
      } else {
        setHealthCompleted({});
      }
      setStepsfilled(prev => [...prev, 0]);
      setRowId(raw.id);
      console.log(raw.id, "IIIDDD", isCompleted, ": Next unfilled step:", nextStep);

    } else {
      // No data found for this email (empty array)
      setStepsfilled(null);
      setCurrentStep(0);
      setAlertMessage("EmailId not found. Please try again.");
      setSeverity("error");
      setOpen(true);
    }

  } catch (error) {
    // Axios sends 404 errors here
    if (error.response?.status === 404) {
      setCurrentStep(0);
      setAlertMessage("EmailId not found. Please try again.");
      setSeverity("error");
      setOpen(true);
      // Optional: don't log 404, it's expected
    } else {
      setAlertMessage("Something went wrong. Please try again later.");
      setSeverity("error");
      setOpen(true);
      console.error("Error fetching data:", error);
    }
  } finally {
    setLoading(false);
  }
};

  const resendOtp = () => {
    sendResumeOtp();
    // setOtp(["", "", "", "", "", ""]);
    // setOtpError(false);
    // setOtpSentMsg(`Verification code re-sent to ${email}`);
    // // optionally regenerate OTP
    // const generatedOtp = Math.floor(100000 + Math.random() * 900000);
    // setGeneratedOtp(generatedOtp);
    // console.log("Resent OTP:", generatedOtp);
  };

  return (
    <div className="landing-screen">
      <div className="landing-card">
        <div className="landing-hero">
          <div className="lh-eyebrow">
            <div className="flex items-center justify-center mb-2">
              <div className="flex items-center space-x-4">
                <img
                  src={BrainyCareLogo}
                  alt="Profile Preview"
                  className="w-10"
                />
                <div className="text-[14px] tracking-[0.32em] text-[var(--gold)] uppercase text-left">
                  Center for Hypertension <br/>& Internal Medicine
                </div>
              </div>
            </div>
          </div>
          <h1>New Patient<br />Registration</h1>
          <p>
            Welcome. Complete your registration at your own pace — your progress is saved automatically after the first page.
          </p>
        </div>

        <div className="landing-body">
          {!showResume && (
            <>
              <button className="landing-btn-primary" onClick={onVerified}>
                Begin Registration
              </button>
              <div className="landing-divider">or</div>
              <button className="landing-btn-secondary" onClick={showResumePanel}>
                Continue Existing Application
              </button>
            </>
          )}

          {showResume && (
            <div className="resume-panel">
              {step === 1 && (
                <div className="email-step">
                  <h3>Enter your email address</h3>
                  <p>We'll send a verification code to the email you registered with.</p>
                  <input
                    type="email"
                    className="resume-input"
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {emailError && (
                    <div className="resume-error">Please enter a valid email.</div>
                  )}
                  <button className="resume-send-btn" onClick={sendResumeOtp}>
                    Send Verification Code →
                  </button>
                  <button className="landing-btn-secondary mt-2" onClick={showBackMainPanel}>
                     Back
                  </button>
                </div>
              )}

              {step === 2 && (
                <div className="otp-step">
                  <h3>Enter your verification code</h3>
                  <p>{otpSentMsg}</p>
                  <div className="otp-inputs">
                    {otp.map((digit, idx) => (
                      <input
                        key={idx}
                        ref={(el) => (otpRefs.current[idx] = el)}
                        className="otp-digit"
                        type="text"
                        maxLength="1"
                        inputMode="numeric"
                        value={digit}
                        onChange={(e) => handleOtpChange(e, idx)}
                      />
                    ))}
                  </div>
                  {otpError && (
                    <div className="resume-error">Incorrect code. Please try again.</div>
                  )}
                  <button className="resume-send-btn" onClick={verifyResumeOtp}>
                    Verify & Resume →
                  </button>
                  <div className="otp-resend">
                    Didn't get it? <button onClick={resendOtp}>Resend code</button>
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="landing-note">
            🔒 Your information is protected by HIPAA-compliant encryption.<br />
            Progress is saved after you verify your contact info on page 1.
          </div>
        </div>
      </div>
    </div>
  );
}